import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, Printer, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import TrainingPlanView from '../components/TrainingPlanView';
import { portalTraining } from '../services/api';

const TrainingPlanPrintPage = () => {
  const { planId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [logs, setLogs] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    portalTraining()
      .then((d) => {
        const p = (d.plans || []).find((x) => x.id === planId) || d.plans?.[0];
        setLogs(d?.workout_logs || []);
        if (p) { setPlan(p); setStatus('ok'); } else setStatus('empty');
      })
      .catch((err) => {
        if (err?.response?.status === 401) navigate('/fiokom/bejelentkezes', { replace: true });
        else setStatus('error');
      });
  }, [planId, navigate]);

  if (status === 'loading') {
    return <div className="min-h-screen bg-white flex items-center justify-center"><Loader2 className="animate-spin text-yellow-600" size={28} /></div>;
  }
  if (status !== 'ok') {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center text-gray-600">
        Nincs megjeleníthető edzésterv.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="print:hidden border-b border-gray-200 px-6 py-3 flex items-center justify-between sticky top-0 bg-white z-10">
        <Button data-testid="print-back-btn" variant="ghost" size="sm" onClick={() => navigate('/fiokom')} className="text-gray-600">
          <ArrowLeft size={14} className="mr-1.5" /> Vissza a fiókomhoz
        </Button>
        <Button data-testid="print-btn" size="sm" onClick={() => window.print()} className="bg-yellow-600 hover:bg-yellow-700 text-white font-bold">
          <Printer size={14} className="mr-1.5" /> Nyomtatás / Mentés PDF-be
        </Button>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="text-center mb-2 text-xs font-bold uppercase tracking-widest text-yellow-700">Orosz Coaching</div>
        <TrainingPlanView plan={plan} mobileCards={false} workoutLogs={logs} />
        <p className="text-xs text-gray-400 mt-8 text-center print:mt-4">
          Készítette: Orosz Gábor · oroszcoaching.hu
        </p>
      </div>
    </div>
  );
};

export default TrainingPlanPrintPage;
